// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import ProductPrice from './ProductPrice';
import Order from '../order/Order';

export default class ProductPrices extends ApiObject {

  onSite: ProductPrice = new ProductPrice();

  takeAway: ProductPrice = new ProductPrice();

  delivery: ProductPrice = new ProductPrice();

  postJsonAssignation(data: Object) {
    this.onSite = new ProductPrice();
    this.onSite.fromJson(data.onSite);

    this.takeAway = new ProductPrice();
    this.takeAway.fromJson(data.takeAway);

    this.delivery = new ProductPrice();
    this.delivery.fromJson(data.delivery);
  }

  // -- utils
  getMode(mode: OrderMode): ?ProductPrice {
    switch (mode) {
      case Order.OrderMode.ON_SITE:
        return this.onSite;
      case Order.OrderMode.TAKE_AWAY:
        return this.takeAway;
      case Order.OrderMode.DELIVERY:
        return this.delivery;
      default:
        console.log('ProductPrices#getMode invalid mode provided', mode);
        // TODO: send error to logger
        return null;
    }
  }

  isModeActivated(mode: OrderMode): boolean {
    return this.getMode(mode).available;
  }

  isValid(): boolean {
    return this.onSite.isValid() && this.takeAway.isValid() && this.delivery.isValid();
  }

}
